import firebase from 'firebase/compat/app'
import 'firebase/compat/database'
import 'firebase/compat/auth'

export default class FirebaseInstance {
  static get() {
    return firebase.database().ref()
  }

  static auth() {
    return firebase.auth()
  }

  /**
   * Pupil sessions last until the tab is closed, so a shared device does not keep the last
   * pupil signed in.
   */
  static useTabSessionPersistence() {
    return firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
  }

  /**
   * Signs out a restored user that is not a pupil session, such as the shared screener account
   * from earlier versions of the app, so it is not used for pupil requests.
   */
  static async signOutUnlessScreenerPupil() {
    const auth = firebase.auth()
    const restoredUser = await new Promise((resolve) => {
      const unsubscribe = auth.onAuthStateChanged((user) => {
        unsubscribe()
        resolve(user)
      })
    })

    if (!restoredUser) {
      return
    }

    const { claims } = await restoredUser.getIdTokenResult()
    if (claims.role !== 'screener-pupil') {
      await auth.signOut()
    }
  }

  static serverTimestamp() {
    return firebase.database.ServerValue.TIMESTAMP
  }
}
